var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTagIcn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 22 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.9048 6.24033L4.08187 14.0632L9.73872 19.7201L17.5616 11.8972L17.0902 6.71173L11.9048 6.24033ZM2.66765 12.649L10.4906 4.82612C10.9103 4.40641 11.4947 4.1948 12.0858 4.24854L17.2713 4.71995C18.2328 4.80736 18.9946 5.56916 19.082 6.53066L19.5534 11.7161C19.6071 12.3072 19.3955 12.8917 18.9758 13.3114L11.1529 21.1343C10.3719 21.9153 9.10556 21.9153 8.32451 21.1343L2.66765 15.4774C1.88661 14.6964 1.8866 13.4301 2.66765 12.649ZM13.9813 9.8206C13.5908 9.43008 13.5908 8.79691 13.9813 8.40639C14.3719 8.01587 15.005 8.01587 15.3956 8.40639C15.7861 8.79691 15.7861 9.43008 15.3956 9.8206C15.005 10.2111 14.3719 10.2111 13.9813 9.8206Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagIcn);
export default __webpack_public_path__ + "static/media/tag-icn.a1c80608d78293706fcf90ae86e6fdf9.svg";
export { ForwardRef as ReactComponent };